import Footer from "components/Footer";
import React from "react";
import { FaArrowRight } from "react-icons/fa";

const templateData = [
  {
    title: "Aurelia — Where Luxury Meets Lifestyle",
    category: "Trusted Developers · Prime Locations · Smart Investments",
    image: "/portfolio-43.png",
    description: "Welcome to Aurelia, a modern real estate brand dedicated to delivering premium residential and commercial properties in prime locations. We focus on transparency, quality construction, and customer-first service for homebuyers and investors.Backed by trusted developers, strong market expertise, and secure processes, Aurelia ensures seamless property searches, site visits, and smooth transactions. Whether it’s your dream home, a luxury apartment, or a high-return investment, Aurelia is committed to helping you invest with confidence and long-term value.",
    link: "https://business.minterminds.in/aurelia/",
  },
  {
    title: "Docify — Smart Healthcare, Made Simple",
    category: "Trusted Doctors · Quality Care · Better Health",
    image: "/portfolio-42.png",
    description: "Welcome to Docify, a modern healthcare platform dedicated to connecting patients with trusted doctors and reliable medical services. We focus on delivering convenient, transparent, and patient-first care for individuals and families.Powered by technology, verified medical professionals, and secure systems, Docify ensures seamless appointments, consultations, and health support. Whether it’s routine care, specialist advice, or ongoing health management, Docify is committed to helping you stay healthy with confidence and ease.",
    link: "https://business.minterminds.in/docify/",
  },
  {
    title: "Crystal — Clean Spaces, Clear Comfort",
    category: "Professional Cleaning · Trusted Service · Spotless Results",
    image: "/portfolio-41.png",
    description: "Welcome to Crystal, a professional cleaning brand dedicated to creating fresh, healthy, and perfectly clean spaces for homes and businesses. Our services are designed to deliver reliability, attention to detail, and consistent quality you can trust.",
    link: "https://business.minterminds.in/crystaltouch/",
  },
  {
    title: "Luxstep — Style That Moves With You",
    category: "Premium Footwear · Style · Everyday Comfort",
    image: "/portfolio-40.png",
    description: "Welcome to Luxstep, a premium footwear brand where modern design meets everyday comfort. Our shoes are crafted to deliver the perfect balance of style, durability, and performance, designed for people who move with confidence and purpose.",
    link: "https://business.minterminds.in/luxstep/",
  },
   {
    title: "Consultivo — Smart Strategy. Real Results.",
    category: "Business Consulting · Strategy · Growth Solutions",
    image: "/portfolio-39.png",
    description: "Welcome to Consultivo, a modern business consulting firm where insight meets execution. We help organizations navigate complex challenges through strategic planning, operational optimization, and performance-driven solutions tailored to their goals.With a results-focused approach, industry expertise, and data-backed decision-making, we empower businesses to scale sustainably, improve efficiency, and achieve measurable long-term success. Whether you’re refining strategy or accelerating growth, Consultivo is your trusted partner in transformation.",
    link: "https://business.minterminds.in/consultivo/",
  },
   {
    title: "INKARA — Art That Stays Forever",
    category: "Tattoo Studio · Custom Ink · Fine Art",
    image: "/portfolio-38.png",
    description: "Welcome to INKARA, a modern tattoo studio where creativity meets precision. We specialize in custom tattoos, fine line work, realism, minimal designs, and bold statement pieces—crafted to reflect your story and individuality.Using premium inks, world-class equipment, and strict hygiene standards, our experienced artists create tattoos that are timeless, safe, and deeply personal. Whether it’s your first tattoo or the next chapter in your collection, INKARA is where your vision becomes permanent art.",
    link: "https://business.minterminds.in/inkara/",
  },
  {
    title: "PlumbMe – Reliable Plumbing, Done Right",
    category: "Plumbing. Repairs. Maintenance.",
    image: "/portfolio-37.png",
    description: "Welcome to PlumbMe, your trusted partner for professional plumbing solutions. We specialize in residential and commercial plumbing services, including leak repairs, pipe installations, drain cleaning, and emergency plumbing support. Using high-quality materials and modern tools, our experienced plumbers deliver efficient, long-lasting solutions with a focus on safety and reliability. Whether it’s a minor fix or a major plumbing project, PlumbMe is here to keep your water systems running smoothly and stress-free.",
    link: "https://business.minterminds.in/plumbme/",
  },
   {
    title: "InspireMe – Awaken Your Inner Power",
    category: "Mindset. Motivation. Growth.",
    image: "/portfolio-35.png",
    description: "Welcome to InspireMe, a motivational platform dedicated to unlocking your true potential and inspiring lasting change. We deliver powerful messages, transformative insights, and practical guidance designed to strengthen your mindset and ignite confidence. Whether you are starting your journey or striving for your next breakthrough, InspireMe empowers you to rise above limitations, take bold action, and create a life driven by purpose, belief, and success.",
    link: "https://business.minterminds.in/inspireme/",
  },
   {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
    title: "Nailio – Perfect Nails, Elevated Style",
    category: "Beauty. Style. Self-Care.",
    image: "/portfolio-36.png",
    description: "Welcome to Nailio, your destination for expert nail care and modern beauty. We specialize in professional manicures, pedicures, and custom nail art designed to enhance your natural beauty and express your personal style. Using premium products and the latest techniques, our skilled nail artists create flawless, long-lasting results in a clean, relaxing environment. Whether you prefer timeless elegance or bold, trend-forward designs, Nailio is here to give your nails the attention they deserve.",
    link: "https://business.minterminds.in/nailio/",
  },
  {
    title: "Yogaverse – A Journey to Mind, Body & Soul",
    category: "Balance. Strength. Mindfulness.",
    image: "/portfolio-34.png",
    description: "Welcome to Yogaverse, a holistic yoga studio dedicated to nurturing physical strength, mental clarity, and inner peace. We offer thoughtfully designed yoga classes that blend traditional practices with modern wellness approaches. From beginners to advanced practitioners, our sessions focus on flexibility, breathwork, mindfulness, and overall well-being—helping you reconnect with yourself and create balance both on and off the mat.",
    link: "https://business.minterminds.in/yoga-studio/",
  },
   {
    title: "MintDigital – Powering Brands Through Digital Marketing",
    category: "Strategy. Growth. Performance.",
    image: "/portfolio24.png",
    description: "Welcome to MintDigital, a results-driven digital marketing studio focused on helping brands grow online. We craft data-backed strategies across SEO, paid media, content, and performance marketing to increase visibility, drive qualified traffic, and convert audiences into customers. From planning to execution, our team delivers measurable growth, scalable solutions, and real business impact.",
    link: "https://business.minterminds.in/mintdigital/",
  },
   {
    title: "Cyberix – Protecting Your Digital World with Confidence",
    category: "Secure. Smart. Resilient.",
    image: "/template21.png",
    description: "Welcome to Cyberix, where cybersecurity meets innovation. We provide comprehensive protection solutions, from threat detection and security assessments to data protection and expert consulting. Our team delivers intelligent strategies, cutting-edge tools, and proactive defense to help businesses stay secure, compliant, and ahead of evolving cyber threats. Experience stronger security, smarter systems, and peace of mind with Cyberix.",
    link: "https://business.minterminds.in/cyberix/",
  },
   {
    title: "ElectroEmpire – Revolutionizing the Way You Experience Technology",
    category: "Smart. Seamless. Empowering.",
    image: "/template19.png",
    description: "Welcome to ElectroEmpire, where innovation meets convenience. Explore the newest gadgets, from high-performance laptops and smartphones to smart home solutions and essential accessories. Our platform offers curated product selections, expert guidance, and speedy delivery, ensuring that staying connected and ahead of technology is effortless. Experience a smarter, faster, and more exciting way to shop tech with ElectroEmpire.",
    link: "https://business.minterminds.in/electro-empire/",
  },
   {
    title: "BookNest – Your Trusted Destination for Books, Anytime, Anywhere",
    category: "Reliable. Comfortable. On Time.",
    image: "/template20.png",
    description: "At BookNest, we bring the joy of reading to your fingertips with a vast selection of books for every taste. Whether you're looking for the latest bestsellers, timeless classics, or niche genres, we've got it all—delivered right to your door. With our easy-to-navigate online store, personalized recommendations, and fast, reliable shipping, BookNest makes it simple to discover your next great read.",
    link: "https://business.minterminds.in/book-nest/",
  },
  {
    title: "SwiftKeys Car Rentals – Smart, Hassle-Free Rides for Every Journey",
    category: "Reliable. Comfortable. On Time.",
    image: "/template17.png",
    description: "SwiftKeys Car Rentals offers dependable, well-maintained vehicles designed to make every trip smooth and stress-free. Whether you need a car for business, travel, or daily commuting, we provide flexible rental options, transparent pricing, and exceptional service—so you can drive with confidence, comfort, and complete peace of mind.",
    link: "https://business.minterminds.in/swift-keys/",
  },
  {
    title: "BrightDrive Car Wash – Professional Care for a Brighter, Cleaner Drive",
    category: "Clean. Safe. Brilliant.",
    image: "/template18.png",
    description: "BrightDrive Car Wash is committed to delivering premium vehicle cleaning that protects your car and enhances its shine. Using advanced technology and eco-friendly products, we ensure every wash is safe, thorough, and reliable—leaving your car spotless, refreshed, and ready for the road.",
    link: "https://business.minterminds.in/car-wash/",
  },
    {
    title: "Love, Captured in Gold & Diamond.",
    category: "Jewellery",
    image: "/template16.webp",
    description:
      "Where luxury meets emotion. Discover jewelry that captures the essence of love through masterful goldwork and dazzling diamonds.",
    link: "https://business.minterminds.in/jewellery/",
  },
   {
    title: "Blocklet – Own Your Time on the Blockchain",
    category: "Blockchain Scheduling Platform",
    image: "/template15.png",
    description:
      "Blocklet is the decentralized appointment and scheduling protocol that puts you in full control. No intermediaries, no double-bookings, no trust required. Powered by smart contracts, every booking is transparent, immutable, and instantly verifiable on-chain — redefining how the world schedules time.",
    link: "https://business.minterminds.in/blocklet/",
  },
   {
    title: "Organic Healthy & Fresh – Nourishing Your Life with Natural Goodness",
    category: "Pure. Fresh. Truly Organic",
    image: "/template8.png",
    description:
      "Organic Healthy & Fresh is dedicated to bringing you premium-quality organic products that support a healthier lifestyle. From farm-fresh fruits and vegetables to wholesome grocery essentials, we deliver purity, freshness, and nutrition in every product—always fresh, always organic, always trusted.",
    link: "https://business.minterminds.in/organic-food/",
  },
    {
    title: "Glowin – Enhancing Your Natural Beauty with Care & Elegance",
    category: "Luxury Spa, Beauty & Salon Services",
    image: "/template9.png",
    description:
      "Glowin offers a premium spa and beauty experience designed to relax, rejuvenate, and refresh your mind and body. From soothing facials and restorative massages to expert hair, nail, and skincare treatments, we combine luxury, comfort, and professional care to help you look and feel your most radiant self.",
    link: "https://business.minterminds.in/glowin/",
  },
      {
    title: "PixPrinting – Bringing Your Ideas to Life in Print",
    category: "High-Quality Printing & Creative Solutions",
    image: "/template10.png",
    description:
      "PixPrinting delivers professional printing services that combine quality, creativity, and precision. From business cards and brochures to banners and custom print products, we turn your concepts into vibrant, tangible results that make your brand stand out and leave a lasting impression.",
    link: "https://business.minterminds.in/pixprint/",
  },
    {
    title: "FloralPixel – Crafting Fresh, Beautiful & Meaningful Floral Designs",
    category: "Premium Floral Art & Elegant Bouquets",
    image: "/template11.png",
    description:
      "FloralPixel creates handcrafted floral arrangements that bring freshness, beauty, and emotion to every moment. From romantic bouquets to elegant décor florals, we turn nature’s colors into art that brightens your space and celebrates life’s special occasions.",
    link: "https://business.minterminds.in/floral-pixel/",
  },
    {
    title: "GlowLiving – Elevate Your Home with Modern & Elegant Décor",
    category: "Premium Home Décor & Interior Styling",
    image: "/template12.png",
    description:
      "GlowLiving brings beautifully curated home décor pieces designed to transform your space with style, warmth, and sophistication. From modern accents to timeless décor essentials, we help you create a home that feels inviting, luxurious, and uniquely yours — effortlessly and beautifully.",
    link: "",
  },
   {
    title: "Kidko – Find, Book & Trust Babysitters Effortlessly",
    category: "Premium Childcare Matching Platform",
    image: "/template13.png",
    description:
      "Kidko is the ultimate babysitting solution trusted by families everywhere. Connect with vetted, experienced caregivers, schedule care instantly, and enjoy peace of mind — all from one user-friendly dashboard. Whether it's a quick evening out, after-school help, or ongoing support, Kidko simplifies childcare, ensuring safety and fun for every child.",
    link: "https://business.minterminds.in/kidko/",
  },
   {
    title: "Eventro – Create, Promote & Manage Events with Ease",
    category: "All-in-One Event Management Platform",
    image: "/template14.png",
    description:
      "Eventro is the complete event management solution trusted by thousands of organizers worldwide. Sell tickets, manage attendees, promote your event, and track performance — all from one beautiful, intuitive dashboard. Whether you're hosting a conference, workshop, or meetup, Eventro makes every step simple, fast, and stress-free.",
    link: "https://business.minterminds.in/eventro/",
  },
  {
    title: "Premium Coworking & Private Offices",
    category: "Workbay Coworking Space",
    image: "/template2.png",
    description:
      "Discover a modern, inspiring workspace designed for productivity and growth. Workbay offers flexible hot desks, dedicated desks, private offices, high-speed internet, meeting rooms, and a vibrant community — everything today’s professionals and teams need to thrive.",
    link: "https://business.minterminds.in/workbay/",
  },
  {
    title: "Luxury Organic Skincare Ritual",
    category: "Pure Beauty Skin Care",
    image: "/template3.png",
    description: "Experience the transformative power of nature with Pure Beauty Skin Care. Crafted with 100% organic, plant-based ingredients and free from harsh chemicals, our luxurious formulations deeply nourish, hydrate, and restore your skin’s natural glow.",
    link: "https://business.minterminds.in/pure/",
  },
  {
    title: "Ultra-Fast Charging with ZapPoint",
    category: "Next-Gen EV Infrastructure",
    image: "/template4.png",
    description: "Power up in minutes, not hours. ZapPoint delivers up to 350 kW ultra-fast charging, 99.9% uptime, contactless payment, and 24/7 reliability — built for today’s electric drivers and tomorrow’s journeys.",
    link: "https://business.minterminds.in/zappoint/",
  },
   {
    title: "Timeless Riviera Elegance Since 1892",
    category: "Luxury Hospitality Redefined",
    image: "/template5.png",
    description: "Experience the legendary EliteStay: palatial sea-view suites, Michelin-starred dining, private beach, and white-glove service on the French Riviera.",
    link: "https://business.minterminds.in/elitestay/",
  },
  {
    title: "More Revenue, Less Complexity",
    category: "Business Strategy & Growth",
    image: "/template6.png",
    description: "Precision strategies and high-impact execution that cut through noise, accelerate growth, and turn ambitious vision into measurable market dominance.",
    link: "https://business.minterminds.in/strategy/",
  },
  {
    title: "Where Less Becomes Luxury",
    category: "BModern Interior Design",
    image: "/template7.webp",
    description: "Intentional design meets exceptional craftsmanship — transforming every room into a gallery of contemporary elegance and serene sophistication.",
    link: "https://business.minterminds.in/Interior-design/",
  },
  {
    title: "Call for delicious Pastries and baked goods",
    category: "Pastries",
    image: "/temp1.webp",
    description:
      "Craving something sweet, warm, and freshly baked? From flaky croissants to rich, come treat yourself today!",
    link: "https://business.minterminds.in/pastries/",
  },
  {
    title: "A place for good traditional wine",
    category: "Wine",
    image: "/temp2.webp",
    description:
      "Celebrating generations of winemaking with bold flavors, old-world charm, and artisanal techniques.",
    link: "https://business.minterminds.in/vintiqwine/",
  },
  {
    title: "Grilled to Greatness.",
    category: "Animal-Based Delights",
    image: "/temp3.webp",
    description:
      "Crafted with passion, perfected with experience — enjoy a variety of non-veg specialties made fresh by culinary professionals.",
    link: "https://business.minterminds.in/meatmelt/",
  },
  {
    title: "Smart & Connected E-Bike",
    category: "E-Bike.",
    image: "/temp4.png",
    description:
      "Experience the future of riding with the SS-100 smart e-bike. Stay connected and navigate the city with ease, enjoying a powerful and silent electric ride.",
    link: "https://business.minterminds.in/automobile/e-bike/",
  },
  {
    title: "Wheels ZQ6",
    category: "Racing Car",
    image: "/temp5.png",
    description:
      "Unleash the mind-blowing speed of the all-new WHEELS ZQ6. Engineered for the track, built for those who dare to dominate.",
    link: "https://business.minterminds.in/automobile/racing-car/",
  }
];

const Template: React.FC = () => {
  return (
    <section className="py-16 bg-white text-center">
      <div className="max-w-6xl mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold mb-4" style={{ color: "#5e5e5e" }}>
            Templates
          </h2>
          <p className="mb-8 text-gray-600">
            We’ve helped startups, businesses, and enterprises bring their ideas
            to life through smart, scalable, and user-focused digital
            solutions. From custom software and mobile apps to blockchain
            platforms and web systems, each project reflects our commitment to
            quality and innovation.
          </p>
        </div>

        {/* Portfolio Cards */}
        <div className="grid gap-8 md:grid-cols-2 pb-16">
          {templateData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl overflow-hidden shadow-xl group relative"
            >
              {/* Image Container with overlay + view more */}
              <div className="relative w-full h-[350px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />

                {/* Black overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition duration-300"></div>

                {/* View More Link */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-300">
                  <div className="absolute inset-0 bg-[#000] bg-opacity-40"></div>
                  <div className="absolute flex bottom-2 right-4 transform transition-all duration-300 group-hover:-translate-y-2">
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#1dc2ef] text-center text-sm bg-[#fff] font-semibold px-4 py-2 rounded-lg flex justify-center items-center hover:bg-white hover:text-black transition"
                    >
                      View Preview
                      <FaArrowRight className="text-lg ml-3" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Text */}
              <div className="p-4 pt-6 text-left">
                <span className="text-sm text-[#1dc2ef] font-medium uppercase">
                  {item.category}
                </span>
                <h3 className="text-xl font-semibold mt-2 group-hover:text-[#1dc2ef] transition">
                  {item.title}
                </h3>
                <p className="text-gray-600 mt-4 text-sm text-[#212529]">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default Template;
